import IOrderItem from "./IOrderItem";

export default class OrderItem implements IOrderItem
{
    constructor(public code: string = "",
                public name: string = "",
                public type: string = "",
                public producer: string = "",
                public quantity: number = 0,
                public totalPrice: string = "",
                public image: string = "",
                public imageFileName: string = "")
    {
    }
}
